import React, { useState , useEffect } from "react";
import Nouislider from "nouislider-react";
import { Label,Form, } from "reactstrap";
import Vectordbchunkcount_Modal from "./CustomModal/Vectordbchunkcount_Modal";

const VectorDBChunkCount = ({ set_vector_chunk_count , _vector_chunk_count  }) => {

  const [mincost, setMincost] = useState(0);
  const [maxcost, setMaxcost] = useState(50);
  //slider function

  const onUpDate = (value) => {
    setMincost(Math.round(value[0]));
    setMaxcost(Math.round(value[1]));
    set_vector_chunk_count(Math.round(value[0]));
  };

  useEffect(() => {
 
    setMincost(_vector_chunk_count);
    setMaxcost(50)
    // setMincost(_vector_chunk_count);
    // console.log("mincost", mincost)W
    // console.log("maxcost", maxcost)
  }, [_vector_chunk_count])
  
  
  return (
    <>
        <div className='vectordbchunkcount mt-4'>
        <Form>
            <Label HtmlFor="vectordbchunkcount" className="form-label">
                Vector DBChunk Count  <Vectordbchunkcount_Modal />
            </Label>
            <div id="nonlinear" data-slider-color="secondary">
                <Nouislider
                range={{
                    min: 0,
                    max: 50,
                }}
                start={_vector_chunk_count ? _vector_chunk_count : 0}
                connect
                onSlide={onUpDate}
                />
            </div>
            <div className="d-flex justify-content-between">
                <div className="example-val" id="lower-value">{mincost}</div>
                {/* <div className="example-val" id="upper-value"></div> */}
                </div>
            </Form>
        </div>
    </>
  )
}

export default VectorDBChunkCount